import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NotificacaoContador, NotificacaoUsuario } from '../interfaces/notificacao/notificacao-usuario.interface';

/** Notificações gravadas do usuário logado (sino do header). Sempre do usuário do token. */
@Injectable({
  providedIn: 'root'
})
export class NotificacaoAPIService {
  private baseUrl = `${environment.APIEndpoint}notificacoes`;

  constructor(private http: HttpClient) { }

  listar(limite = 30) {
    return this.http.get<NotificacaoUsuario[]>(`${this.baseUrl}?limite=${limite}`);
  }

  contador() {
    return this.http.get<NotificacaoContador>(`${this.baseUrl}/contador`);
  }

  marcarLida(id: number) {
    return this.http.put(`${this.baseUrl}/${id}/lida`, {});
  }

  /** "Limpar" do sino. */
  marcarTodasLidas() {
    return this.http.put(`${this.baseUrl}/lidas`, {});
  }

  /** As da origem (ex.: o chamado aberto pelo toast). */
  marcarLidasDaOrigem(entidade: string, origemId: number) {
    return this.http.put(`${this.baseUrl}/origem/${encodeURIComponent(entidade)}/${origemId}/lidas`, {});
  }
}
